<template>
  <div class="beds-chart-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">
          <i class="fas fa-bed title-icon"></i>
          Leitos
        </h3>
        <p class="card-subtitle">Disponíveis e Indisponíveis</p>
      </div>
    </div>

    <div class="card-content">
      <ErrorsMessages :errors="errors" />

      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <div class="beds-stats">
          <!-- Total Beds -->
          <div class="stat-item total-beds">
            <div class="stat-icon">
              <i class="fas fa-hospital"></i>
            </div>
            <div class="stat-content">
              <div class="stat-label">Leitos Cadastrados</div>
              <div class="stat-value">{{ beds }}</div>
            </div>
          </div>

          <!-- Used Beds -->
          <div class="stat-item used-beds">
            <div class="stat-icon">
              <i class="fas fa-user-injured"></i>
            </div>
            <div class="stat-content">
              <div class="stat-label">Leitos Ocupados</div>
              <div class="stat-value">{{ usedBeds }}</div>
            </div>
            <div class="stat-progress">
              <div
                class="progress-bar used-progress"
                :style="{ width: usedPercentage + '%' }"
              ></div>
            </div>
          </div>

          <!-- Available Beds -->
          <div class="stat-item available-beds">
            <div class="stat-icon">
              <i class="fas fa-bed"></i>
            </div>
            <div class="stat-content">
              <div class="stat-label">Leitos Vazios</div>
              <div class="stat-value">{{ unusedBeds }}</div>
            </div>
            <div class="stat-progress">
              <div
                class="progress-bar available-progress"
                :style="{ width: availablePercentage + '%' }"
              ></div>
            </div>
          </div>
        </div>

        <!-- Visual Indicator -->
        <div class="beds-visual">
          <div class="visual-header">
            <h4 class="visual-title">
              <i class="fas fa-chart-pie mr-2"></i>
              Distribuição
            </h4>
          </div>
          <div class="visual-content">
            <div class="beds-indicator">
              <div class="indicator-section used-section">
                <div class="indicator-color used-color"></div>
                <span class="indicator-label"
                  >Ocupados ({{ usedPercentage }}%)</span
                >
              </div>
              <div class="indicator-section available-section">
                <div class="indicator-color available-color"></div>
                <span class="indicator-label"
                  >Vazios ({{ availablePercentage }}%)</span
                >
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import api from "../../services/api";

export default {
  name: "UsedAndUnusedBeds",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      beds: 0,
      usedBeds: 0,
      unusedBeds: 0,
      errors: [],
      loading: false,
    };
  },
  computed: {
    usedPercentage() {
      if (this.beds === 0) return 0;
      return Math.round((this.usedBeds / this.beds) * 100);
    },
    availablePercentage() {
      if (this.beds === 0) return 0;
      return Math.round((this.unusedBeds / this.beds) * 100);
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/graphics/used-and-unused-beds"
        );

        const { beds, usedBeds, unusedBeds, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.beds = beds.total;
          this.usedBeds = usedBeds.total;
          this.unusedBeds = unusedBeds.total;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.beds-chart-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  height: fit-content;
}

.card-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  padding: 20px;
  border-bottom: 1px solid #f59e0b;
}

.header-content {
  text-align: center;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #92400e;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-icon {
  color: #d97706;
  margin-right: 8px;
  font-size: 16px;
}

.card-subtitle {
  color: #92400e;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.card-content {
  padding: 24px;
}

.loading-overlay {
  border-radius: 12px;
  min-height: 200px;
}

/* Beds Stats */
.beds-stats {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.stat-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  position: relative;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.total-beds {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
}

.used-beds {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fca5a5;
}

.available-beds {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: #86efac;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 16px;
  color: white;
}

.total-beds .stat-icon {
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
}

.used-beds .stat-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.available-beds .stat-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stat-content {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

/* Progress Bars */
.stat-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.8s ease;
}

.used-progress {
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
}

.available-progress {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

/* Visual Indicator */
.beds-visual {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.visual-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.visual-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.visual-title i {
  color: #0f65b0;
}

.visual-content {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.beds-indicator {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.indicator-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.indicator-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.used-color {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.available-color {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.indicator-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* Responsive Design */
@media (max-width: 768px) {
  .card-content {
    padding: 16px;
  }

  .card-header {
    padding: 16px;
  }

  .stat-item {
    padding: 12px;
  }

  .stat-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
    margin-right: 12px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-label {
    font-size: 13px;
  }

  .beds-visual {
    padding: 16px;
  }

  .visual-content {
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .card-title {
    font-size: 16px;
    flex-direction: column;
    gap: 4px;
  }

  .card-subtitle {
    font-size: 13px;
  }

  .stat-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .stat-value {
    font-size: 18px;
  }

  .indicator-section {
    gap: 8px;
  }

  .indicator-label {
    font-size: 13px;
  }
}
</style>